import { render, staticRenderFns } from "./forms-control.vue?vue&type=template&id=5837f39d&scoped=true&"
import script from "./forms-control.vue?vue&type=script&lang=js&"
export * from "./forms-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837f39d",
  null
  
)

export default component.exports